import MaintainerTicketListView from '../../components/MaintainerTicketListView';

MaintainerTicketListScreen.propTypes = {};

function MaintainerTicketListScreen(props) {
    // MARK: ---- PROPERTIES ----
    const { isMine } = props;

    return (
        <div>
            <div className="my-4">
                <MaintainerTicketListView isMine={isMine} />
            </div>
        </div>
    );
}

export default MaintainerTicketListScreen;
